import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { navigate } from 'gatsby';

import '../styles/index.scss';

import HeaderDesk from '../components/desktop/header/header-desk';
import FooterDesk from '../components/desktop/footer/footer-desk';
import MainFeatureSectionDesk from '../components/desktop/sections/main-feature-section-desk';

import detectOsSzn from '../helpers/detectOsSzn';
import sectionData from '../section-data';


const MainSection = () => {
  const components = {
    MainFeatureSection: MainFeatureSectionDesk,
  };

  return sectionData.map((data) => {
    const Template = components[data.sectionType];
    return <Template key={data.id} sectionContent={data} />;
  });
};

class IndexPage extends React.Component {
  mainFeatureSections = sectionData.map((data) => <MainFeatureSectionDesk key={data.id} sectionContent={data} />);

  constructor(props) {
    super(props);

    this.state = { show: false };
  }

  componentWillMount() {
    if (typeof window !== `undefined`) {
      const browser = detectOsSzn.Browser.detect();

      if (window && browser.name !== 'Seznam.cz') {
        window.location.replace('https://www.seznam.cz/prohlizec');
      }
      this.setState({ show: true });
    }
  }

  render() {
    if (this.state.show) {
      return (
        <div>
          <Helmet>
            <title>Prohlížeč Seznam.cz</title>
          </Helmet>
          <HeaderDesk />
          <MainSection />
          <FooterDesk />
        </div>
      );
    }
    return (<div></div>);
  }
}

export default IndexPage;
